import { Contact } from "@/@types";
import Image from "next/image";
import Link from "next/link";

const DefaultContact = {
  phone: "800 22 MATCO",
  email: "info@matco.com.mx",
  schedule: "8:00am-6:00pm",
  facebook: "https://www.facebook.com/matcocat",
  linkedin: "https://www.linkedin.com/company/empresas-matco-s-a-de-c-v-/",
  youtube: "https://www.youtube.com/channel/UCp-CjnPJSeCPbW306cMqMMA",
  instagram: "https://www.instagram.com/matcocatmx/?hl=es-la",
};

type Props = {
  contact?: Contact;
};

function SocialLink({ href, src, alt }: { href: string; src: string; alt: string }) {
  if (href === "#" || href === "") return null;

  const formattedHref =
    href.startsWith("http://") || href.startsWith("https://")
      ? href
      : `https://${href}`;

  return (
    <Link href={formattedHref} target="_blank" rel="noopener noreferrer">
      <Image
        width={20}
        height={20}
        src={src}
        alt={alt}
        className="filter brightness-50 saturate-0"
      />
    </Link>
  );
}

export default function BookletAboutUs({ contact }: Props) {
  const facebook = contact?.facebook || DefaultContact.facebook;
  const linkedin = contact?.linkedin || DefaultContact.linkedin;
  const youtube = contact?.youtube || DefaultContact.youtube;
  const instagram = contact?.instagram || DefaultContact.instagram;

  return (
    <div className="mb-1">
      <div className="bg-white py-6 px-4 shadow-md text-center space-y-2">
        <h3 className="text-xl font-bold text-dark02 uppercase">NOSOTROS</h3>
        <p className="text-gray03 text-xl">
          Matco ofrece la línea completa de maquinaria Caterpillar, con más de 300 modelos como camiones,
          tractores, excavadoras, retroexcavadoras y equipo para minería. Explora las categorías en su sitio
          para encontrar la máquina ideal y asegurar el éxito de tu operación.
        </p>
        <div className="mt-4">
          <div className="text-2xl flex justify-center items-center mt-2 gap-5 text-gray03">
            <SocialLink href={facebook} src="/images/icons/facebook.svg" alt="Facebook" />
            <SocialLink href={linkedin} src="/images/icons/linkedin.svg" alt="LinkedIn" />
            <SocialLink href={youtube} src="/images/icons/youtube.svg" alt="YouTube" />
            <SocialLink href={instagram} src="/images/icons/instagram.svg" alt="Instagram" />
          </div>
        </div>
      </div>
    </div>
  );
}
